/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDomainExpansionTicketData } from './CRSFDomainExpansionTicketData';
import {
    CRSFDomainExpansionTicketDataFromJSON,
    CRSFDomainExpansionTicketDataFromJSONTyped,
    CRSFDomainExpansionTicketDataToJSON,
} from './CRSFDomainExpansionTicketData';
import type { CRSFScanType } from './CRSFScanType';
import {
    CRSFScanTypeFromJSON,
    CRSFScanTypeFromJSONTyped,
    CRSFScanTypeToJSON,
} from './CRSFScanType';

/**
 * 
 * @export
 * @interface CRSFDomainExpansionTicketResponse
 */
export interface CRSFDomainExpansionTicketResponse {
    /**
     * 
     * @type {CRSFDomainExpansionTicketData}
     * @memberof CRSFDomainExpansionTicketResponse
     */
    data?: CRSFDomainExpansionTicketData;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainExpansionTicketResponse
     */
    process_id: string;
    /**
     * 
     * @type {CRSFScanType}
     * @memberof CRSFDomainExpansionTicketResponse
     */
    scan_type: CRSFScanType;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainExpansionTicketResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainExpansionTicketResponse
     */
    ticket: string;
}

/**
 * Check if a given object implements the CRSFDomainExpansionTicketResponse interface.
 */
export function instanceOfCRSFDomainExpansionTicketResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "scan_type" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "ticket" in value;

    return isInstance;
}

export function CRSFDomainExpansionTicketResponseFromJSON(json: any): CRSFDomainExpansionTicketResponse {
    return CRSFDomainExpansionTicketResponseFromJSONTyped(json, false);
}

export function CRSFDomainExpansionTicketResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainExpansionTicketResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CRSFDomainExpansionTicketDataFromJSON(json['data']),
        'process_id': json['process_id'],
        'scan_type': CRSFScanTypeFromJSON(json['scan_type']),
        'status': json['status'],
        'ticket': json['ticket'],
    };
}

export function CRSFDomainExpansionTicketResponseToJSON(value?: CRSFDomainExpansionTicketResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CRSFDomainExpansionTicketDataToJSON(value.data),
        'process_id': value.process_id,
        'scan_type': CRSFScanTypeToJSON(value.scan_type),
        'status': value.status,
        'ticket': value.ticket,
    };
}

